import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DateFormatterService } from '@frontend/sports/common/core/feature/date-formatter-service';
import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { OddsFormatterService } from '@frontend/sports/odds/feature';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { BaseBetslipGroupPick } from 'packages/sports/common/betslip/core/picks/betslip-group-pick';
import { BetslipPick } from 'packages/sports/common/betslip/core/picks/betslip-pick';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { IBetslipOverAskPickComponentProps } from '../../../models/over-ask.model';

@Component({
    selector: 'bs-digital-over-ask-group-pick',
    templateUrl: './betslip-over-ask-group-pick.component.html',
    styleUrls: ['./betslip-over-ask-group-pick.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOverAskGroupPickComponent {
    props = input.required<IBetslipOverAskPickComponentProps>();
    oddsDisplayFormat = input.required<OddsDisplayFormat>();
    private isEpcotEnabled: boolean;
    groupPick = computed(() => this.props().overAskPick.pick as BaseBetslipGroupPick);
    date = computed(() => this.dateFormatterService.formatDateWithTime(this.groupPick().eventDate));
    pickList = computed(() => {
        return this.groupPick().getLegs();
    });

    headerText = computed(() => {
        if (this.isEpcotEnabled) {
            return this.interpolationPipe.transform(this.sitecore.betBuilderEntainUI.messages?.PicksHeaderTitle ?? '', {
                legsCount: this.pickList().length,
            });
        }

        return this.sitecore.globalMessages.BetBuilderBadgeText;
    });

    eventName = computed(() => this.groupPick().eventName.name);

    groupPrice = computed(() => {
        return this.groupPick().acceptedPrice
            ? this.oddsFormatterService.format(this.groupPick().acceptedPrice.price!.nativeOdds, { displayFormat: this.oddsDisplayFormat() })
            : '';
    });

    constructor(
        private interpolationPipe: StringInterpolationPipe,
        private sitecore: Sitecore,
        private dateFormatterService: DateFormatterService,
        private oddsFormatterService: OddsFormatterService,
        private epcotConfigService: EpcotConfigService,
    ) {
        this.isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Betslip);
    }

    optionName(pick: BetslipPick): string {
        return pick.optionName.name;
    }

    marketName(pick: BetslipPick): string {
        return pick.marketName.name;
    }
}
